import Crud from '../views/Stock/Crud'

let routes = {
    path: '/estoque',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/estoque',
            name: 'list-stock',
            component: Crud,
            meta: {
                pageTitle: '',
                breadcrumb: [
                    { text: 'Estoque', active: true },
                ],
            },
        },
    ]
};

export default routes
